import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";
import HowToVoteOutlinedIcon from "@mui/icons-material/HowToVoteOutlined";
import PetsOutlinedIcon from "@mui/icons-material/PetsOutlined";
import TouchAppOutlinedIcon from "@mui/icons-material/TouchAppOutlined";
import SelfImprovementOutlinedIcon from "@mui/icons-material/SelfImprovementOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import RightSideCardShell from "./RightSideCardShell";
import AnimatedRainbowBorder from "./AnimatedRainbowBorder";

interface ManifestoPopupProps {
  onClose: () => void;
}

// Darker, saturated versions of the app's rainbow — legible on white
const RAINBOW = [
  "#E0544A", // coral
  "#B327C2", // magenta
  "#4F52E8", // indigo
  "#0891B2", // cyan
  "#16A34A", // green
  "#C57D00", // amber
  "#D97706", // orange
  "#E0544A", // coral
  "#B327C2", // magenta
  "#4F52E8", // indigo
];

const ITEMS: { icon: React.ElementType; text: string }[] = [
  { icon: PeopleAltOutlinedIcon,       text: "Contribute to the internet. Collaborate when possible." },
  { icon: FavoriteBorderIcon,          text: "Share love, knowledge and opinions." },
  { icon: BugReportOutlinedIcon,       text: "Always give feedback. Report broken things." },
  { icon: LabelOutlinedIcon,           text: "Take NSFW tags seriously." },
  { icon: HowToVoteOutlinedIcon,       text: "Be political." },
  { icon: PetsOutlinedIcon,            text: "Share cat/dog memes. After all, the internet was made for it." },
  { icon: TouchAppOutlinedIcon,        text: 'Be mindful before pressing any button that says "Allow".' },
  { icon: SelfImprovementOutlinedIcon, text: "Correct your posture. Don't forget to blink. Stay hydrated." },
  { icon: LockOutlinedIcon,            text: "Never share your OTP." },
  { icon: PublicOutlinedIcon,          text: "Don't Zuck up the internet." },
];

const ManifestoPopup: React.FC<ManifestoPopupProps> = ({ onClose }) => {
  return (
    <RightSideCardShell
      onClose={onClose}
      widthClassName="w-[390px]"
      heightClassName="h-auto"
      panelStyle={{ width: "min(390px, calc(100vw - 40px))", height: "auto", maxHeight: "calc(100vh - 56px)" }}
    >
      {(requestClose) => (
        <AnimatedRainbowBorder className="h-full flex flex-col">
          {/* Header */}
          <div className="px-6 pt-5 pb-3 flex justify-between items-start shrink-0">
            <div>
              <p className="gilroy-regular text-[10px] tracking-[0.18em] uppercase text-black/30 mb-1">
                Dearest Internet
              </p>
              <h1 className="text-black text-[18px] leading-tight" style={{ fontFamily: "'Kurdis Bold'" }}>
                Our Better Internet<br />Manifesto
              </h1>
            </div>
            <button
              onClick={requestClose}
              className="text-black/50 hover:text-black border border-black/20 hover:border-black/50 rounded-full p-1 cursor-pointer bg-transparent transition-all duration-200 shrink-0 mt-0.5"
            >
              <CloseIcon sx={{ fontSize: 14 }} />
            </button>
          </div>

          {/* Rainbow divider */}
          <div
            className="mx-6 shrink-0"
            style={{
              height: "1.5px",
              background: "linear-gradient(90deg,#F4958E,#FFAAF7,#9193FC,#B4F6FE,#B0FFC0,#FEFF9D,#F3D9A0)",
              opacity: 0.7,
            }}
          />

          {/* List */}
          <ul className="px-6 pt-5 pb-6 space-y-3.5">
            {ITEMS.map(({ icon: Icon, text }, i) => (
              <li key={i} className="flex items-start gap-3">
                <Icon
                  sx={{ fontSize: 17, marginTop: "2px", flexShrink: 0, color: RAINBOW[i] }}
                />
                <span className="gilroy-medium text-black text-[14px] leading-snug">
                  {text}
                </span>
              </li>
            ))}
          </ul>
        </AnimatedRainbowBorder>
      )}
    </RightSideCardShell>
  );
};

export default ManifestoPopup;
